<div class="overlay" [ngClass]="display">
  <mat-spinner></mat-spinner>
</div>
